
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 8v10a1 1 0 01-1 1h-1a1 1 0 01-1-1V8H7a1 1 0 01-1-1V6a1 1 0 011-1h10a1 1 0 011 1v1a1 1 0 01-1 1h-3.5z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    